/* ============= Tab =============  */
document.addEventListener('DOMContentLoaded', function(){	
	const tabs = document.getElementsByClassName('c-tab');
	for(let i = 0; i < tabs.length; i++) {
		tabs[i].addEventListener('click', tabSwitch);
	}
	function tabSwitch(){	
		const ancestorEle = this.closest('.c-tab-panel');		
		ancestorEle.getElementsByClassName('is-active')[0].classList.remove('is-active');
		this.classList.add('is-active');		
		ancestorEle.getElementsByClassName('is-show')[0].classList.remove('is-show');
		const groupTabs = ancestorEle.getElementsByClassName('c-tab');
		const arrayTabs = Array.prototype.slice.call(groupTabs);
		const index = arrayTabs.indexOf(this);
		ancestorEle.getElementsByClassName('c-panel')[index].classList.add('is-show');
	};
});

/* ============= モバイル メインメニュー（アコーディオン） =============
   ・theme.js のスライド式の代わりに、ハンバーガーメニュー内でアコーディオン開閉する
   ・行全体（リンク / コレクション画像タブ / シェブロン）のクリックで開閉
*/
document.addEventListener('click', function(e){
	if(window.innerWidth > 1023) return;

	const item = e.target.closest('.mobile-nav-menu-container .main-nav__has-dropdown, .mobile-nav-menu-container .main-nav__child-has-dropdown');
	if(!item) return;

	const trigger = item.querySelector(':scope > .js-nav-accordion');
	if(!trigger) return;

	const clicked = e.target.closest('.js-nav-accordion, .main-nav__link, .main-nav__child-link, .exp-tab-link');
	if(!clicked) return;

	const directTriggers = [
		item.querySelector(':scope > .js-nav-accordion'),
		item.querySelector(':scope > .main-nav__link'),
		item.querySelector(':scope > .main-nav__child-link'),
		item.querySelector(':scope > .exp-tab-link')
	];
	if(directTriggers.indexOf(clicked) === -1) return;

	let panel = trigger.nextElementSibling;
	while(panel && panel.tagName !== 'UL'){
		panel = panel.nextElementSibling;
	}
	if(!panel) return;

	e.preventDefault();
	trigger.classList.toggle('is-active');
	panel.classList.toggle('is-open');
	trigger.setAttribute('aria-expanded', panel.classList.contains('is-open'));
}, true);